import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'

export const UPDATE_USER_ADMIN = gql`
  mutation UpdateUserAdminMutation($input: UpdateUserAdminInput!) {
    updateUserAdmin(input: $input) {
      user {
        id
        admin
      }
    }
  }
`

const UpdateUserAdmin = ({ userId, children }) => (
  <Mutation mutation={UPDATE_USER_ADMIN}>
    {mutate =>
      children(admin =>
        mutate({
          variables: { input: { userId, admin } },
          optimisticResponse: {
            updateUserAdmin: {
              __typename: 'UpdateUserAdminPayload',
              user: {
                __typename: 'User',
                id: userId,
                admin
              }
            }
          }
        })
      )
    }
  </Mutation>
)

export default UpdateUserAdmin



// WEBPACK FOOTER //
// ./src/mutations/UpdateUserAdmin.js